import BaseController from "controllers/backend/base"

import ResultsFilterWidget from "widgets/backend/resultsFilterWidget"
import ExportDealerDataWidget from "widgets/backend/exportDealerDataWidget"

class Controller extends BaseController {
  call() {
    super.call()
    bindResultsFilter.call(this)
    bindCheckAllCheckbox.call(this)
    submitBulkAction.call(this)
  }
};

var bindResultsFilter = function() {
  let elem = this.root
  this.exportDealer = new ExportDealerDataWidget(elem)
  this.resultsFilter = new ResultsFilterWidget(elem)
}

var fetchBulkAction = function(bulkAction, groupId, userIds, force) {
  $.ajax({
    url: `/backend/user_groups/bulk_${bulkAction}.json`,
      dataType: 'json',
      method: 'PUT',
      data: {
        group_id: groupId,
        user_ids: userIds,
        force: force
      },
      success: (r) => {
        console.log('Succeed');
        handleBulkSuccess.call(this)
      },
      error: (xhr, text, error) => {
        swal({
          type: 'question',
          title: 'Alert',
           text: 'If you proceed only dealers that belong to the accounts of the dealer group will be updated.'+
            ' Do you wish to proceed?',
          showCancelButton: true,
        }).then(() => {
          if (!force) {
            fetchBulkAction.call(this, bulkAction, groupId, userIds, true)
          }
        })
      }
  });
}

var handleBulkSuccess = function() {
  this.resultsFilter = new ResultsFilterWidget(this.root);
}

var submitBulkAction = function() {
  this.root.find('#submit-bulk-action').on("click", (e) => {
    const selectAll = document.querySelector('.check_all_group').checked;
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    const groupId = document.querySelector('#by_bulk_group_action').value;
    const bulkAction = document.querySelector('#bulk_action').value;
    let userIds = [];

    if (selectAll) {
      for (var i=1, n = checkboxes.length; i < n; i++) {
        userIds.push(checkboxes[i].value)
      }
    } else {
      for (var i=1, n = checkboxes.length; i < n; i++) {
        if (checkboxes[i].checked) {
          userIds.push(checkboxes[i].value)
        }
      }
    }

    if (bulkAction == '') {
      swal({
        type: 'error',
        title: 'Please select bulk action either assign or remove',
      })
      return false
    } else if (userIds.length === 0) {
      swal({
        type: 'error',
        title: 'Please select a dealer',
      })
      return false
    }

    fetchBulkAction.call(this, bulkAction, groupId, userIds, false);
    this.resultsFilter = new ResultsFilterWidget(this.root);
  })
}

var bindCheckAllCheckbox = function() {
  this.root.on('.check_all_group').on("click", (e) => {
    if (e.target.name === 'All') {
      let checkboxes = document.getElementsByName('group');
      for (var i=0, n = checkboxes.length; i < n; i++) {
        checkboxes[i].checked = document.querySelector('.check_all_group').checked;
      }
    }
  })
}

export default Controller;
